export default {
    HOUSE: 'House',
    APARTMENT: 'Apartment',
    APARTMENT_ACROSS_COURTYARD: 'Apartment across courtyard',
}
